import { ReactNode } from 'react';

export const HIGHLIGHT_COLOR = 'rgb(181, 251, 241)';

export interface HighlightTextOptions {
  fullNameShortCircuit?: boolean;
}

export function highlightText(
  text: string,
  searchText: string | null | undefined,
  options: HighlightTextOptions = {}
): ReactNode {
  if (!searchText || !text) return text;

  if (
    options.fullNameShortCircuit &&
    searchText.toLowerCase().includes(text.toLowerCase())
  ) {
    return <span style={{ backgroundColor: HIGHLIGHT_COLOR }}>{text}</span>;
  }

  const escapedTerm = searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const parts = text.split(new RegExp(`(${escapedTerm})`, 'gi'));

  return (
    <>
      {parts.map((part, i) =>
        part.toLowerCase() === searchText.toLowerCase() ? (
          <span key={i} style={{ backgroundColor: HIGHLIGHT_COLOR }}>
            {part}
          </span>
        ) : (
          <span key={i}>{part}</span>
        )
      )}
    </>
  );
}
